module.exports = "<div class=\"row text-center\" style=\"margin: 10% auto;\">\r\n  <h3>Registration Successful</h3>\r\n  <p class=\"lead\">Please check your email to verify your Nexpress<small><sup>&reg;</sup></small> account.</p>\r\n</div>\r\n\r\n"


//////////////////
// WEBPACK FOOTER
// C:/Users/EricChanney/Apps/nexpress-angular-site/src/app/component/check-email/check-email.component.html
// module id = ../../../../../src/app/component/check-email/check-email.component.html
// module chunks = main